/**
 * This file handles the interactions with the OAT Services Payment Estimator and the
 * BAT PE iFrame.
 */
import $ from 'jquery';
import tdaConfig from 'lib/util/tda.config';
import storageUtil from 'utils/storage-util';
import getParameterByName from 'lib/getParameterByName';
import zip from 'lib/util/zip';
import zipTools from 'components/zip-tools';
import langFromUrl from 'lib/util/langFromUrl';
import blocks from 'lib/analytics/blocks/index';
import anComponentView from 'lib/analytics/componentView';
import anClicks from 'lib/analytics/click';
import anAddContext from 'lib/analytics/context.add';
import PageCache from 'lib/page-cache';
import 'postMessage';

// add #pe-debug to the URL for console.log debugging
var peDEBUG = window.location.hash === '#pe-debug';
var iframe = document.getElementById('pe-iframe');
// BAT-5199.PROCEED WHEN IFRAME IS LOADED.
var iFLoadCallback = function (event) {
  setTimeout(function () {
    var confirmedZip = storageUtil.isConfirmedZip();
    peDEBUG && console.log( ' IF LOAD CALLBACK: ', event);
    var initMethod = {
      method: 'init',
      brand: 'toyota',
      breakpoints: {
        tablet: 700,
        desktop: 900
      },
      source: 'bat'
    };
    var initMethodStr = JSON.stringify(initMethod);
    iframe.contentWindow.postMessage(initMethodStr, '*');
    if (confirmedZip) {
      peDEBUG && console.log('A: have a confirmed zip, calling zipchange');
      var zipchangeMethod = {
        method: 'zipchange',
        zip: storageUtil.getZip(),
      };
      var zipChangeMehtodStr = JSON.stringify(zipchangeMethod);
      // send the new zip to the iframe via postMessage
      iframe.contentWindow.postMessage(zipChangeMehtodStr, '*');
    }
  }, 1500);
};

if (iframe) {
  iframe.onload = iFLoadCallback;
}
/**
 * Main PaymentEstimatorIFrame class
 */
var PaymentEstimatorIFrame = {

  init: function (containerEl, iframeEL, config) {
    peDEBUG && console.log( 'PEIF INIT:', containerEl, iframeEL, config);
    var self = this;
    this.$scope = $(containerEl);
    self.defaultTrimCode = '';
    // MOSTLY INTERESTED IN iframeEL, containerEl maybe used in futrure.
    var currentTDACode = tdaConfig.tda.code;
    peDEBUG && console.log( ' ::: peIFrame INIT ::: $scope', this.$scope);
    var confirmedZip = storageUtil.isConfirmedZip();
    peDEBUG && console.log( ' ::: confirmedZip ::: ', confirmedZip);
    var $peIframe = $('#bat-payment-estimator-iframe');
    if ($peIframe.length) {
      // log the previous URL if on an iframe page,
      // this will be the URL that the back button
      // leads to
      var oldURL = document.referrer;
      peDEBUG && console.log('previous URL: ' + oldURL);
      $peIframe.attr('data-ref-url', oldURL);
      var isOldUrlPushedOnStack = false;

      peDEBUG && console.log('pe-iframe div exists on this page');
      peDEBUG && console.log('Confirmed Zip: ' + confirmedZip);

      var iframeSrc = $peIframe.data('src');
      iframeSrc = 'https://' + location.hostname + iframeSrc;

      if (window.location.hostname === 'localhost') {
        iframeSrc = 'http://localhost:9000/#/';
      }
      // for local testing only
      // iframeSrc = 'https://test.national.aws.buyatoyota.com' + iframeSrc;
      peDEBUG && console.log('iframe src: ' + iframeSrc);

      // These query string params will come from various CTAs, each
      // CTA will probably pass different parameters
      var zipParam = getParameterByName('zip');
      var yearParam = getParameterByName('year');
      var seriesParam = getParameterByName('series');
      var trimCodeParam = getParameterByName('trimCode');
      var msrpParam = getParameterByName('msrp');
      var modelParam = getParameterByName('model');
      var offerId = getParameterByName('offerid');
      var offerType = getParameterByName('offerType');
      var offerRate = getParameterByName('offerRate');
      var monthlyPmt = getParameterByName('monthlyPmt');
      var offerSubType = getParameterByName('offerSubType');
      var offerCashBack = getParameterByName('offerCashBack');

      if (seriesParam && seriesParam === 'c-hr') {
        seriesParam = 'chr';
      }
      var lang = langFromUrl();

      var queryStringParamsObj = {
        zip: zipParam,
        year: yearParam,
        series: seriesParam,
        trim: trimCodeParam,
        model: modelParam,
        msrp: msrpParam,
        offerId: offerId,
        offerType: offerType,
        offerRate: offerRate,
        monthlyPmt: monthlyPmt,
        offerSubType: offerSubType,
        offerCashBack: offerCashBack,
        lang: lang
      };

      peDEBUG && console.log(
        'zipParam =      ' + zipParam + '\n' +
              'yearParam =     ' + yearParam + '\n' +
              'seriesParam =   ' + seriesParam + '\n' +
              'trimCodeParam = ' + trimCodeParam + '\n' +
              'modelParam =    ' + modelParam + '\n' +
              'msrpParam =    ' + msrpParam + '\n' +
              'offer =       ' + offerId + '\n' +
              'offerType =     ' + offerType + '\n' +
              'offerRate =     ' + offerRate + '\n' +
              'monthlyPmt =    ' + monthlyPmt + '\n' +
              'offerSubType =  ' + offerSubType + '\n' +
              'offerCashBack = ' + offerCashBack +
              'lang =          ' + lang
      );
      var queryParams;
      var isFromDirectLink = false;
      var hasQueryParams = false;
      if (!zipParam && !yearParam && !seriesParam && !trimCodeParam && !modelParam && !offerId) {
        // if no query string params, we are going to the PE directly
        // (like from the footer link) and not from a CTA
        peDEBUG && console.log('no query string params found');
        isFromDirectLink = true;
        queryParams = PaymentEstimatorIFrame.buildSrcForDirectLink();
      } else {
        queryParams = PaymentEstimatorIFrame.buildSrcFromQueryStringParams(queryStringParamsObj);
      }

      if ((queryParams && queryParams.length > 0) && !isFromDirectLink) {
        iframeSrc = iframeSrc + 'estimator' + queryParams;
        hasQueryParams = true;
      } else if ((queryParams && queryParams.length > 0) && isFromDirectLink) {
        // if from direct link, do not set variable hasQueryParams to true
        // there are not any true query string params, we are just adding
        // one after the fact so the iframe can quickly load the vehicle
        // select screen
        iframeSrc = iframeSrc + queryParams;
      }
      peDEBUG && console.log('iframe src = ' + iframeSrc);
      // update the iframe source this way to not add an entry in the
      // browser history when the source changes
      // $('#pe-iframe').attr('src', iframeSrc);
      var iFrame = document.getElementById('pe-iframe');
      if (iFrame && iFrame.contentWindow) {
        iFrame.contentWindow.location.replace(iframeSrc);
      }

      // This sets a default width and height before the iframe loads,
      // in case something happens and the loading does not happen,
      // the iframe will look decent
      var w = $('#bat-payment-estimator-iframe').parent().width();
      // not sure if sm or md should be different than lg
      var DEFAULT_HEIGHT = 280;
      $('#pe-iframe').attr('height', DEFAULT_HEIGHT);

      setTimeout(function () {
        // data used to initialize the iframe
        var initMethod = {
          method: 'init',
          brand: 'toyota',
          breakpoints: {
            tablet: 700,
            desktop: 900
          },
          source: 'bat'
        };
        // var initMethodStr = JSON.stringify(initMethod);
        if (iFrame && iFrame.contentWindow) {
          peDEBUG && console.log( ' ::: iFrame and contentWindow Present ::: ');
          // BAT-5199 moved up to iframe load. see:iFLoadCallback
          if (!confirmedZip && hasQueryParams) {
            var defaultZip = $('#defaultzipcode').attr('defaultzipcode');
            storageUtil.setZip(defaultZip);
            storageUtil.setConfirmedZip(true);
            zipTools.updateZipFields(defaultZip);
          }
          // this makes for a better user experience, without showing
          // or hiding the iFrame there is a small collapsed iframe
          // to the left of the page when loading
          $('#pe-iframe').fadeTo('fast', 1);
        }

        /**
         * Resizes the PE iFrame to fit the content
         * This function passes in the height from the postMessage from the parent
         * @param {Number} height - the height to resize the iFrame
         */
        var setIframeSize = function (height) {
          peDEBUG && console.log(' ::: setting iFrame height to: ' + height);

          // set the height and width dynamically
          iFrame.height = height;
          if (height == '200') {
            $(window).scrollTop(0);
          }
          // postMessage does not pass back the width, only the height
          // var contentWidth  = $('#bat-payment-estimator-iframe').parent().width();
          // peDEBUG && console.log('setting iFrame width to: ' + contentWidth);
          // iFrame.width = contentWidth;
        }; // end setIframeSize

        $.receiveMessage(function (event) {
          // peDEBUG && console.log(event.origin);
          // if (event.origin.indexOf('buyatoyota.com') == -1 || event.origin.indexOf('localhost') == -1) {
          //    return;
          // }
          if (typeof event.data !== 'string') { // WE REJECT MESSAGES THAT ARE NOT STRING.
            peDEBUG && console.log(' NOT STRING ', event.data)
            return;
          }
          try {
            peDEBUG && console.log(':::: message received: ', typeof event.data,  event.data, event);
            var jsonObject = JSON.parse(event.data);
            peDEBUG && console.log(' :::: jsonObject:', jsonObject);
            var key = Object.keys(jsonObject)[0];
            peDEBUG && console.log(' ::: key: ' + key);
            var value = '';
            if (key) {
              // value = event.data[key];
              value = jsonObject[key];
              // if (key == 'stateChange') {
              // no longer using this.
              // }
              // for sizing the iframe to the correct height
              if (key === 'iframeHeight') {
                setIframeSize(value);
              }
              // the old way of setting zip
              /*
              if (key === 'setZipSingle') {
                //
              }
              */
            }
          } catch (error) {
            console.log('  ::: RECEIVE MESSAGE ERROR', error);
          }
        });

        /**
       * On PE submit button click, get the (valid) zip code, and either proceed
       * to the vehicle select window, or give the change zip modal if out-of-region.
       */
        $('#pe-iframe').contents().find('#zipcode-button').click(function (e) {
          var submittedZip = $('#pe-iframe').contents().find('#zipcode').val();
          var isNumber = false;
          if (submittedZip.match(/^\d+$/)) {
            isNumber = true;
          }
          if (isNumber && (submittedZip && submittedZip.length == 5)) {
            peDEBUG && console.log('PE click submit zip: ' + submittedZip);

            // callback for use in zipTools.getTDA, which provides us with dealerdata
            var getPESubmitCallback = function (data) {
              peDEBUG && console.log('in getPESubmitCallback');
              peDEBUG && console.log(data);
              var cnt = data.entityList.length;
              if (cnt > 0) {
                var tda = data.entityList[0].tdaCode;
                peDEBUG && console.log('New TDA: ' + tda + ', Current TDA: ' + currentTDACode);

                // if the TDAs are the same, the PE will load the results
                if (tda === currentTDACode) {
                  if (submittedZip && !storageUtil.isConfirmedZip()) {
                    storageUtil.setZip(submittedZip);
                    storageUtil.setConfirmedZip(true);
                    zipTools.updateZipFields(submittedZip);
                    zipTools.changeZip(
                      storageUtil.getZip(),				// current zip
                      submittedZip,						// new zip
                      zipTools.getSiteHomePath(),	// redirect path
                      undefined,							// final callback
                      false,								// isSkipConfirmZipChangeModal
                      false);								// isInventoryModal
                  }
                  // if the TDAs are different, zipTools will give the modal to forward to the new TDA
                } else {
                  var redirectPath = zipTools.getSiteHomePath() + 'payment-estimator/';
                  if (submittedZip && (submittedZip != storageUtil.getZip())) {
                    zipTools.changeZip(
                      storageUtil.getZip(), // current zip
                      submittedZip, // new zip
                      redirectPath, // redirect path
                      undefined, // final callback
                      false, // isSkipConfirmZipChangeModal
                      false // isInventoryModal
                    );
                  }
                }
              }
            };

            zipTools.getTDA(submittedZip, getPESubmitCallback);
          }
          e.preventDefault();
        });
      }, 2000); // end setTimeout
    } // end if $peIframe exists

    /*
      Detect when the zip code from the parent changes, when it does we need
      to pass the new zip to the PE iframe via postMessage.
    */
    // $(window).on('ZIP_CODE_CHANGED', function () {
    PageCache.on('ZIP_CODE_CHANGED', function () {
      peDEBUG && console.log('zip code changed');
      // get the new zip code
      var newZip = storageUtil.getZip();
      peDEBUG && console.log('New Zip: ' + newZip);
      // still probably need to verify if the iframe element exists
      var iFrame = document.getElementById('pe-iframe');
      if (iFrame && iFrame.contentWindow) {
        // this is how the zipchange is called in postMessage
        var zipchangeMethod = {
          method: 'zipchange',
          zip: newZip
        };
        var zipChangeMehtodStr = JSON.stringify(zipchangeMethod);
        peDEBUG && console.log(zipChangeMehtodStr);
        // send the new zip to the iframe via postMessage
        if (newZip.length) {
          iFrame.contentWindow.postMessage(zipChangeMehtodStr, '*');
        }
      }
    }); // end window ZIP_CODE_CHANGED
    self.analytics();
  },
  analytics: function () {
    var self = this;
    var $scope = self.$scope;
    anAddContext(
      $scope,
      blocks.sectionBlock('Payment Estimator')
    );
    anClicks($scope); // PE CLICKS ARE HANDLED INTERNALLY IN PE.
    anComponentView($scope);
  }
};

// variable to hold the trim code from the ajax call in getDefaultTrimCode function below
//PaymentEstimatorIFrame.defaultTrimCode = '';

/**
 * This function is used when the PE is launched via a CTA with query string
 * parameters, the parameters need to be parsed and passed in to the iframe
 * src for the proper page to load
 *
 * @param {Object} params - an object of all the query string params
 * @return {String} queryString - the concatenated query string params
 */
PaymentEstimatorIFrame.buildSrcFromQueryStringParams = function (params) {
  // peDEBUG && console.log('in buildSrcFromQueryStringParams', params);

  var zipParam = params.zip;
  var year = params.year;
  var series = params.series;
  var trim = params.trim;
  var model = params.model;
  var msrp = params.msrp;
  var offerId = params.offerId;
  var offerType = params.offerType;
  var offerRate = params.offerRate;
  var monthlyPmt = params.monthlyPmt;
  var offerSubType = params.offerSubType;
  var offerCashBack = params.offerCashBack;
  var lang = params.lang;

  var queryString = '?';

  if (zipParam) {
    queryString += 'zip=' + zipParam + '&';
  } else {
    // if no zip query param exists, see if we have a confirmed
    // zip code, and add that to the queryString, if no confirmed
    // zip, then use the defaultzip attribute on the page
    peDEBUG && console.log('no zip query string param, checking for confirmed zip');
    if (storageUtil.isConfirmedZip()) {
      queryString += 'zip=' + storageUtil.getZip() + '&';
      peDEBUG && console.log('confirmed zip is ' + storageUtil.isConfirmedZip());
    } else {
      var defaultZip = $('#defaultzipcode').attr('defaultzipcode');
      if (defaultZip && defaultZip.length > 0) {
        peDEBUG && console.log('no confirmed zip, using defaultzipcode attribute');
        peDEBUG && console.log('defaultzipcode attribute: ' + defaultZip);
        queryString += 'zip=' + defaultZip + '&';
      } else if (zip.getCookiedDefaultFallback()) {
        queryString += 'zip=' + zip.getCookiedDefaultFallback() + '&';
        peDEBUG && console.log('no confirmed zip, default is ' + zip.getCookiedDefaultFallback());
        } else {
          peDEBUG && console.log('defaultzipcode attribute does not exist or was not found');
        // eslint-disable-next-line indent
        }
    }
  }

  if (year) {
    queryString += 'year=' + year + '&';
  }
  if (lang) {
    queryString += 'lang=' + lang + '&';
  }
  if (series) {
    if (series == 'c-hr') {
      series = 'chr';
    }
    queryString += 'series=' + series + '&';
  }
  if (msrp) {
    queryString += 'msrp=' + msrp + '&';
  }
  if (offerId) {
    queryString += 'offer=' + offerId + '&';
  }

  if (offerType) {
    /*
          * For APR, pass the rate (ex. 2.9) for offerValue
          * For Cash, pass the Cash Back amount for offerValue
          * Otherwise pass the montly payment (ex. 299)
          */
    if (offerType == 'APR') {
      queryString += 'offerType=' + offerType + '&';
      queryString += 'offerValue=' + offerRate + '&';
    } else if (offerType == 'Cash') {
      queryString += 'offerType=' + offerType + '&';
      queryString += 'offerValue=' + offerCashBack + '&';
    } else if (offerType == 'Miscellaneous') {
      /*
              * If the offer type Miscellaneous, Paul requested we pass the actual
              * type of offer from the subtype label, else just pass the regular
              * type
              */
      queryString += 'offerType=' + offerSubType + '&';
      // not sure if cash back is the correct value for misc
      queryString += 'offerValue=' + offerCashBack + '&';
    } else {
      queryString += 'offerType=' + offerType + '&';
      queryString += 'offerValue=' + monthlyPmt + '&';
    }

    // if offerType param exists, the CTA was from offer detail
    // note that trimCode and model are reversed for offer detail
    // and inventory detail
    // offer detail CTA:
    //     trimCode = 4440
    //     model    = XLE
    //
    // inventory detail CTA:
    //     trimCode = XLE
    //     model    = 3544
    if (trim) {
      var trimLastFour = trim.substr(trim.length - 4);
      queryString += 'trim=' + trimLastFour + '&';
    }
  } else {
    // the CTA was not from offer detail, it was from inventory
    // so use the correct param for trim
    if (model) {
      var modelLastFour = model.substr(model.length - 4);
      queryString += 'trim=' + modelLastFour + '&';
    } else if (trim) {
      var trimLastFour = trim.substr(trim.length - 4);
      queryString += 'trim=' + trimLastFour + '&';
    } else {
      peDEBUG && console.log('Vehicle Info CTA');
      // if we get here, the CTA was from vehicle info,
      // try to get the default trim and add it as a
      // parameter, and then this will not cause the
      // back button to get "stuck" while clicking
      // around in the PE

      // this will call CLS via ajax to get the first trim
      // in the trimInfoModels list for the series and year
      this.getDefaultTrimCode(year, series);
      peDEBUG && console.log('this.defaultTrimCode: ' + this.defaultTrimCode);
      if (this.defaultTrimCode && this.defaultTrimCode.toString().length > 0) {
        queryString += 'trim=' + this.defaultTrimCode.toString() + '&';
      }
    }
  }

  // if the last character in the query string is an ampersand,
  // remove it from the string
  var c = queryString.slice(-1);
  if (c && c == '&') {
    queryString = queryString.slice(0, -1);
  }

  if (queryString.length == 1) {
    queryString = '';
  }

  peDEBUG && console.log('new queryString params = ' + queryString);

  return queryString;
}, // end buildSrcFromQueryStringParams

/**
 * If coming to PE from a direct link with no query string params, set the
 * iframe src to the VehicleSelect screen if we have a confirmed zip.
 *
 * Example of URL:
 * https://test.southerncalifornia.aws.buyatoyota.com/bat-pe/#/vehicleSelect?zip=90210
 *
 */
PaymentEstimatorIFrame.buildSrcForDirectLink = function () {
  var queryString = '';
  if (storageUtil.isConfirmedZip()) {
    queryString = 'vehicleSelect?zip=' + storageUtil.getZip();
  }

  if(langFromUrl() && langFromUrl()!== 'en') {
    if(!queryString || queryString ==='') {
      queryString = '?lang=es';
    } else {
      queryString += '&lang=es';
    }
  }
  return queryString;
}, // end buildSrcForDirectLink

/**
 * Gets the local zip, either from storage utils, or the default zip
 * from tda-config.
 *
 * @return zipCode - the local zipcode
 */
PaymentEstimatorIFrame.getLocalZip = function () {
  var zipCode = '';
  if (storageUtil.isConfirmedZip()) {
    zipCode = storageUtil.getZip();
  } else {
    zipCode = $('#defaultzipcode').attr('defaultzipcode');
  }
  return zipCode;
}, // end getLocalZip

/**
 * Set the zipcode input field in the iFrame with the BAT
 * confirmed zip if it exists
 * @param {String} zip - the confirmed zip used to update the iFrame input
 */
PaymentEstimatorIFrame.setZipcode = function (zip) {
  // @TODO this does set the value but when you click submit it behaves
  // as empty and gives and error, wut do??
  // $('#pe-iframe').contents().find('#zipcode').val(zip);
  $('#pe-iframe').contents().find('#zipcode').attr('value', zip);
}, // end setZipcode


/**
 * This function reloads and initializes the iframe, basically
 * when the orientation or size changes this will reload the frame
 * with the correct size:
 *    1) make sure the iframe exists
 *    2) call postMessage to initialize, this should also
 *       resize the iframe
 */
PaymentEstimatorIFrame.reloadIframe = function () {
  var iframe = document.getElementById('pe-iframe');
  if (iframe && iframe.contentWindow) {
    var getHeightMethod = {
      method: 'getHeight'
    };
    var getHeightMethodStr = JSON.stringify(getHeightMethod);
    iframe.contentWindow.postMessage(getHeightMethod, '*');
  }
}, // end reloadIframe

/**
 * This function calls CLS to get a default trim if one is not provided via
 * the CTA params, PE needs a trim for all calls, if one is not provided, PE
 * will do a look up and append the trim to the query string params, which does
 * work, but causes bad side effects with the back button, the user will forever
 * stay trapped in PE
 *
 * @param {String} year   - the year from the query string param
 * @param {String} series - the series from the query string param
 */
PaymentEstimatorIFrame.getDefaultTrimCode = function (year, series) {
  var seriesTrimService = '/BATWS/cls/getTrimModel/' + year + '/' + series.toLowerCase() + '.json';
  peDEBUG && console.log('making CLS call to get a default trim');

  $.ajax({
    dataType: 'json',
    url: seriesTrimService,
    success: function (data) {
      peDEBUG && console.log('trim data: ', data);
      if (data) {
        for (var key in data.trimModelInfo.models) {
          PaymentEstimatorIFrame.defaultTrimCode = data.trimModelInfo.models[key][0].trimId;
          peDEBUG && console.log('CLS call succeeded, defaultTrimCode: ', PaymentEstimatorIFrame.defaultTrimCode);
          break;
        }
      }
    },
    fail: function (data) {
      peDEBUG && console.log('CLS call failed, trim ID will be null');
    },
    async: false
  });
}; // getDefaultTrimCode

/**
 * When the window loads, check if the iframe exists, if so, do ALL the
 * things, if not, it could be timing, or maybe the service is down...
 * TODO: possible options if the iframe does not yet exist
 *       1) retry?
 *       2) put up an error modal?
 *       3) display the iframe with a default size?
 */
export default PaymentEstimatorIFrame;

